import CloseIcon from 'assets/icons/ims/Close3.svg'
import ClockIcon from 'assets/icons/ims/Clock.svg'
import EditIcon from 'assets/icons/ims/Edit.svg'
import OkIcon from 'assets/icons/ims/Ok.svg'
import DocIcon from 'assets/icons/ims/Doc.svg'

// titleKey rather than a title: this map is a module constant, so it cannot
// hold text for a language that is chosen at runtime. Callers translate it.
export const STATUS_MAP: Record<number, { titleKey: string; color: string; bg: string }> = {
  1: { titleKey: 'protocols:status_draft',    color: '#4C5564', bg: '#F1F5F9' },
  2: { titleKey: 'protocols:status_pending',  color: '#D08700', bg: '#FEF9C2' },
  3: { titleKey: 'protocols:status_approved', color: '#00A63E', bg: '#DCFCE7' },
  4: { titleKey: 'protocols:status_rejected', color: '#E7000B', bg: '#FEE2E2' },
}

export const getIconByStatus = (protocolStatusId: number) => {
  if (protocolStatusId == 4) return CloseIcon
  if (protocolStatusId == 1) return EditIcon
  if (protocolStatusId == 2) return ClockIcon
  if (protocolStatusId == 3) return OkIcon
  if (protocolStatusId == 0) return DocIcon
}
